<template>
  <div class="bg-white text-[#0A0A0A]">
    <div class="border-b-[1px] border-[#E5E5E5] w-full px-[1.5rem] py-[1rem]">
      <h3 class="mb-0 text-lg font-semibold text-[#0A0A0A]">
        Pusat Bantuan
      </h3>
    </div>

    <div class="px-[1.5rem] py-[1rem]">
      <div class="bg-[#F5F5F5] w-fit p-[3px] rounded-[8px]">
        <button
          v-for="item in TAB_LIST"
          :key="item.value"
          class="px-[1rem] py-[0.25rem] rounded-[6px] rounded-[6px] border-[1px] transition-color"
          :class="activeTab === item.value ? 'bg-white border-[#F5F5F5] shadow-sm' : 'border-transparent'"
          @click="activeTab = item.value"
        >
          {{ item.title }}
        </button>
      </div>
    </div>
    <div class="px-[1.5rem] py-[1rem]">
      <artikel-component v-if="activeTab === 'article'" />
      <category-component v-if="activeTab === 'category'" />
    </div>
  </div>
</template>

<script>
import { TAB_LIST } from './config'
import CategoryComponent from './Category.vue'
import ArtikelComponent from './Artikel.vue'

export default {
  name: 'HelpCenter',
  components: {
    CategoryComponent,
    ArtikelComponent,
  },
  data() {
    return {
      activeTab: this.$route.query.tab || 'article',
      TAB_LIST,
    }
  },
  watch: {
    activeTab(newTab) {
      if (this.$route.query.tab !== newTab) {
        this.$router.replace({ query: { tab: newTab } }).catch(() => {})
      }
    },
  },
}
</script>
